import React, {FC, useMemo} from 'react';

import {InboxesPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {LensModel} from '../../../../../models/api/lensModel';
import {makeGetLensWithInboxesNamespace} from '../../../../../store/data/lenses/lensesSelectors';
import {editLensAsyncAction, LensTemplate} from '../../../../../store/data/lenses/saveLensActions';
import {getUserNamespace} from '../../../../../store/data/teammates/teammatesSelectors';
import {LensesWorkspaceDialog, LensesWorkspaceDialogBaseProps} from './lensesWorkspaceDialog';

interface LensesWorkspaceEditDialogContainerProps
  extends Omit<LensesWorkspaceDialogBaseProps, 'userNamespace' | 'onSubmit'> {
  panelId: InboxesPanelId;
  lens: LensModel;
  onDelete: () => void;
}

export const LensesWorkspaceEditDialog: FC<LensesWorkspaceEditDialogContainerProps> = (props) => {
  const {onDelete, panelId} = props;
  const userNamespace = useAppSelector(getUserNamespace);
  const getLensWithInboxesNamespace = useMemo(
    () => makeGetLensWithInboxesNamespace(props.lens),
    [props.lens],
  );
  const lensWithInboxesNamespace = useAppSelector(getLensWithInboxesNamespace);

  const dispatch = useAppDispatch();
  const editLensAsync = (template: LensTemplate) =>
    dispatch(editLensAsyncAction({inboxesPanelId: panelId, template}));
  const onSubmit: (template: LensTemplate) => Promise<void> = async (template) => {
    await editLensAsync(template);
  };

  return (
    <LensesWorkspaceDialog
      {...props}
      userNamespace={userNamespace}
      onSubmit={onSubmit}
      isEditing
      lens={lensWithInboxesNamespace}
      onDelete={onDelete}
    />
  );
};
